import { render, staticRenderFns } from "./LocationCarrierZones.vue?vue&type=template&id=f2a56b14&"
import script from "./LocationCarrierZones.vue?vue&type=script&lang=js&"
export * from "./LocationCarrierZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports